<template>
  <div class="answers-container">
    <IziGrid
      v-for="(answer, index) of question.answers"
      :key="index"
      class="list-answers"
    >
      <IziCol xl="1" lg="1" md="1" col="1" class="seledc-answer">
        <RadioButton :value="answer.name" v-model="question.correctAnswer" />
      </IziCol>
      <IziCol xl="10" lg="10" md="10" col="10">
        <IziInput label="Enter your answer" v-model:value="answer.name" />
      </IziCol>
      <IziCol
        xl="1"
        lg="1"
        md="1"
        col="1"
        class="col-remove-answer"
        v-if="question.answers.length > 1"
      >
        <IziIcon @click="removeAnswer(index)">clear</IziIcon>
      </IziCol>
    </IziGrid>
    <IziGrid>
      <IziCol
        class="col-add-answer"
        col="6"
        v-show="question.answers.length < 8"
      >
        <IziButton
          @click="addAnswer"
          label="Add answer option"
          buttonType="primary"
          theme="text"
          icon="pi pi-plus-circle"
        ></IziButton>
      </IziCol>
    </IziGrid>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { Answer } from "../../../../../model/Answer.model";
import Base from "../../../../base/Base.vue";
@Options({
  props: ["question"]
})
export default class Answers extends Base {
  question: any = [];
  removeAnswer(index: any) {
    this.question.answers.splice(index, 1);
  }

  addAnswer() {
    this.question.answers.push({ name: "" } as Answer);
  }
}
</script>
